import { castDraft, produce } from 'immer';

import { Lumber, MaterialSettings } from '@paragon/contract-library';
import {
  getClosestLumberToProposedLumber,
  lumberCanBeUsedForComponentThickness,
  lumbersAreEqual,
} from '@paragon/material-lists';

export function getValidLumber(lumber: Lumber, validLumbers: Lumber[], thickness?: number) {
  const lumberIsValid =
    (thickness === undefined || lumberCanBeUsedForComponentThickness(lumber, thickness)) &&
    validLumbers.some((validLumber) => lumbersAreEqual(validLumber, lumber));
  if (lumberIsValid) {
    return lumber;
  }

  return getClosestLumberToProposedLumber(validLumbers, lumber, thickness);
}

/**
 * Ensure that the provided material settings use lumbers from the provided lumber array.
 */
export function restrictMaterialSettingsLumbers(
  settings: MaterialSettings,
  validLumbers: Lumber[],
  thickness?: number,
): MaterialSettings {
  return produce(settings, (draftSettings) => {
    draftSettings.topChordLumber = castDraft(getValidLumber(draftSettings.topChordLumber, validLumbers, thickness));
    draftSettings.bottomChordLumber = castDraft(
      getValidLumber(draftSettings.bottomChordLumber, validLumbers, thickness),
    );
    draftSettings.webLumber = castDraft(getValidLumber(draftSettings.webLumber, validLumbers, thickness));
    draftSettings.bearingBlockLumber = castDraft(
      getValidLumber(draftSettings.bearingBlockLumber, validLumbers, thickness),
    );
    draftSettings.endVerticalLumber = castDraft(
      getValidLumber(draftSettings.endVerticalLumber, validLumbers, thickness),
    );
    draftSettings.gableStudLumber = castDraft(getValidLumber(draftSettings.gableStudLumber, validLumbers, thickness));
    draftSettings.sliderLumber = castDraft(getValidLumber(draftSettings.sliderLumber, validLumbers, thickness));

    // for feature pattern trusses only
    draftSettings.ribbonBlockLumber = castDraft(
      getValidLumber(draftSettings.ribbonBlockLumber, validLumbers, thickness),
    );

    // for profile trusses only
    draftSettings.wedgeLumber = castDraft(getValidLumber(draftSettings.wedgeLumber, validLumbers, thickness));
  });
}
